import type { ComponentType } from 'react';
import { PremiumGlassFullBoard } from './PremiumGlassFullBoard';

export const BESPOKE_DESIGNS: Record<string, ComponentType> = {
  'premium-glass-full': PremiumGlassFullBoard,
};

export function isBespoke(id: string | undefined): boolean {
  return !!id && id in BESPOKE_DESIGNS;
}
